import { CreateExternalAppDto, ExternalAppApi, ExternalAppDto } from '../../../api-client';
import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

type UseCreateExternalApp = (
  options?: Omit<
    UseMutationOptions<AxiosResponse<ExternalAppDto>, ErrorResponse, CreateExternalAppDto>,
    'mutationFn'
  >,
) => UseMutationResult<AxiosResponse<ExternalAppDto>, ErrorResponse, CreateExternalAppDto>;

export const useCreateExternalApp: UseCreateExternalApp = (options) => {
  const api = new ExternalAppApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;

  return useMutation(
    (createExternalAppDto: CreateExternalAppDto) =>
      api.createExternalApp(tenantId, createExternalAppDto),
    options,
  );
};
